import { Thread } from "@/models/Thread";
import { Body1, makeStyles, tokens } from "@fluentui/react-components";
import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";

type Props = {
  thread: Thread;
};
export const ThreadLink: React.FC<Props> = ({ thread }: Props) => {
  const navigate = useNavigate();
  const { threadId } = useParams<{ threadId: string; }>();
  const classes = useStyles();
  return (
    <Body1
      className={threadId === thread.id ? classes.selected : classes.title}
      onClick={() => navigate("/threads/" + thread.id)}
    >
      {thread.title}
    </Body1>
  );
};

const useStyles = makeStyles({
  title: {
    display: "block",
    margin: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalS}`,
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalS}`,
    borderRadius: tokens.borderRadiusMedium,

    ":hover": {
      "background": tokens.colorNeutralBackground4Hover,
      "cursor": "pointer",
    },
  },
  selected: {
    display: "block",
    margin: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalS}`,
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalS}`,
    borderRadius: tokens.borderRadiusMedium,
    background: tokens.colorNeutralBackground4Selected,
    cursor: "pointer",

    ":hover": {
      "background": tokens.colorNeutralBackground4Hover,
    },
  },
});
